import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {Pagination} from 'antd'
import LoaderInTable from '../../../components/loader/LoaderInTable'
import BlankDataImageInTable from '../../../components/basic/BlankDataImageInTable'
import {ModelPopUpDelete} from '../../../components/modal-popup/ModelPopUpDelete'
import Header_Search_Add from '../../../components/table-header/Header_Search_Add'
import {ModelPopUpIsActive} from '../../common-pages/ModelPopUpIsActive'
import {UserModel} from '../../../modules/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {Button, Modal} from 'react-bootstrap-v5'
import {NewModelRequestCard} from './NewModelRequestCard'
import {IVehicleModel} from '../../../models/vehicle-manage-model/IVehicleTypeModel'
import {
  DeleteVehicleAPI,
  GetVehicleListAPI,
  IsActiveVehicleAPI,
} from '../../../modules/vehicle-manage-master-page/vehicle-master-page/VehicleRUD'
import {KTSVG} from '../../../../_CarWash/helpers'
import {INewModelRequest} from '../../../models/vehicle-manage-model/INewModelRequest'
import {
  GetNewModelRequestListAPI,
  UpdateNewModelRequestStatusAPI,
} from '../../../modules/vehicle-manage-master-page/new-model-request-master-page/NewModelRequestCRUD'
import {modelStatusData} from './AddNewModelRequest'

interface IItem {
  loading: boolean
  newModelRequestData: INewModelRequest[]
  temNewModelRequestData: INewModelRequest[]
  imageShow: string
  SearchText: string
  selItemName: string
  selNewModelRequestID: number
  selStatusID: number
  pathUrl: any
  selBannerTitle: string
}

type Props = {}

const NewModelRequestList: React.FC<Props> = () => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [state, setState] = useState<IItem>({
    loading: false,
    newModelRequestData: [] as INewModelRequest[],
    temNewModelRequestData: [] as INewModelRequest[],
    imageShow: '',
    SearchText: '',
    selItemName: '',
    selNewModelRequestID: 0,
    selStatusID: 0,
    pathUrl: process.env.REACT_APP_API_URL,
    selBannerTitle: '',
  })

  useEffect(() => {
    setState({...state, loading: true})
    setTimeout(() => {
      getNewModelRequestData()
    }, 100)
  }, [])

  // ==================== Get Item API Call===================
  function getNewModelRequestData() {
    GetNewModelRequestListAPI()
      .then((response) => {
        let responseData = response.data.responseObject
        if (response.data.isSuccess === true) {
          setState({
            ...state,
            newModelRequestData: responseData,
            temNewModelRequestData: responseData,
            loading: false,
          })
          setTotal(responseData.length)
        } else {
          toast.error(`${response.data.message}`)
          setState({...state, newModelRequestData: [], loading: false})
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setState({...state, newModelRequestData: [], loading: false})
      })
  }

  // ===================== Status Change Model ==================
  const [showChange, setShowChange] = useState(false)
  const handleshowChange = (temNewModelRequestID: number, temStatusID: number) => {
    setState({...state, selStatusID: temStatusID, selNewModelRequestID: temNewModelRequestID})
    setShowChange(true)
  }

  const handleCloseChange = () => setShowChange(false)
  const selectChange = (event: any) => {
    const value = event.target.value
    const elementId = event.target.id
    if (elementId === 'statusID') {
      setState({...state, selStatusID: parseInt(value)})
    }
  }

  function updateStatusData(temNewModelRequestID: number, temStatusID: number) {
    UpdateNewModelRequestStatusAPI(temNewModelRequestID, temStatusID)
      .then((repon) => {
        if (repon.data.isSuccess === true) {
          toast.success(`Status Updated Successfully`)
          getNewModelRequestData()
          setShowChange(false)
        } else {
          toast.error(`${repon.data.message}`)
          setShowChange(false)
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setShowChange(false)
      })
  }

  // ==================== Delete Model ============
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = (temNewModelRequestID: number) => {
    setState({
      ...state,
      selNewModelRequestID: temNewModelRequestID,
      loading: false,
    })
    setShow(true)
  }

  // ==================== Delete API Call ===================
  const deleteVehcileData = (temVehcileID: number) => {
    DeleteVehicleAPI(temVehcileID)
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success('Deleted Successfully')
          getNewModelRequestData()
          setShow(false)
        } else {
          toast.error(`${response.data.message}`)
          setShow(false)
        }
      })
      .catch((error) => {
        toast.error(`${error}`)
        setShow(false)
      })
  }

  // ============== Search Function =======================
  const [name, setName] = useState('')
  //------------------- the search result-----------------
  const filter = (e: any) => {
    const keyword = e.target.value
    if (keyword !== '') {
      const results = state.temNewModelRequestData.filter((user) => {
        return (
          user.vehicleMakeName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.vehicleModelName.toLowerCase().startsWith(keyword.toLowerCase()) ||
          user.noOfSeat.toString().startsWith(keyword.toLowerCase()) ||
          user.customerName.toLowerCase().startsWith(keyword.toLowerCase())
        )
      })
      setState({...state, newModelRequestData: results, loading: false})
      setTotal(results.length)
    } else {
      setState({...state, newModelRequestData: state.temNewModelRequestData, loading: false})
      // If the text field is empty, show all users
      setTotal(state.temNewModelRequestData.length)
    }

    setName(keyword)
  }

  // ----------------------pagination---------------------------------------------
  const onShowSizeChange = (current: any, pageSize: any) => {
    setPostPerPage(pageSize)
  }

  const [total, setTotal] = useState(0) //  length
  const [page, setPage] = useState(1)
  const [postPerPage, setPostPerPage] = useState(10)
  const indexOfLastPage = page * postPerPage
  const indexOfFirstPage = indexOfLastPage - postPerPage
  const currentPosts: INewModelRequest[] = state.newModelRequestData.slice(
    indexOfFirstPage,
    indexOfLastPage
  )
  // -----------

  return (
    <>
      <div className={`card `}>
        {/* begin::Header */}
        {/* <div className='card-header border-0 bg-secondary'>
          <div className='card-header border-0 pt-4 ps-0' id='kt_chat_contacts_header'>
            <form className='w-100 position-relative' autoComplete='off'>
              <KTSVG
                path='/media/icons/duotune/general/gen021.svg'
                className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute pt-14 ms-5 translate-middle-y'
              />
              <input
                type='text'
                className='form-control form-control-solid px-15 bg-white'
                name='search'
                placeholder='Search'
                onChange={(e) => filter(e)}
                value={name}
              />
            </form>
          </div>
        </div> */}
        <Header_Search_Add
          searchText={name}
          filter={(e) => filter(e)}
          pathName={'/vehicle/new-model-request/add'}
          title='Click to add a new model request'
        />
        {/* end::Header */}
        {/* <CountryCard data={currentPosts} /> */}
        {/* begin::Body */}
        <div className='py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-striped align-middle g-4'>
              {/* begin::Table head */}
              <thead className='bg-primary'>
                <tr className='fw-bold fs-7 text-white text-uppercase'>
                  <th className='min-w-100px'>Customer Name</th>
                  <th className='min-w-100px'>Mobile</th>
                  <th className='min-w-125px'>Make Name</th>
                  <th className='min-w-150px'>Model Name</th>
                  <th className='min-w-100px'>No Of Seat</th>
                  <th className='min-w-100px'>Status</th>
                  {/* <th className='min-w-100px'>Is Active</th> */}
                  <th className='min-w-150px text-end'>Edit | Delete </th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {state.loading ? (
                  <LoaderInTable loading={state.loading} column={7} />
                ) : (
                  <>
                    {currentPosts.length > 0 &&
                      currentPosts.map((data, index) => {
                        return (
                          <NewModelRequestCard
                            data={data}
                            // handleShowActive={(e: React.ChangeEvent<HTMLInputElement>) =>
                            //   handleShow_Active(e)
                            // }

                            handleshowChange={() =>
                              handleshowChange(data.newModelRequestID, data.statusID)
                            }
                            handleShow={handleShow}
                          />
                        )
                      })}
                    {/* =================== Loading get Api Data ============== */}
                    <BlankDataImageInTable
                      length={currentPosts.length}
                      loading={state.loading}
                      colSpan={7}
                    />
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className='text-center'>
            <Pagination
              onChange={(value: any) => setPage(value)}
              pageSize={postPerPage}
              total={total}
              current={page}
              showSizeChanger
              showQuickJumper
              onShowSizeChange={onShowSizeChange}
              showTotal={(total) => `Total ${total} items`}
            ></Pagination>
          </div>
        </div>
      </div>
      {/* =====================Delete Model PopUp=============== */}
      <ModelPopUpDelete
        id={state.selNewModelRequestID}
        pageName={'New Model Request'}
        show={show}
        handleClose={handleClose}
        deleteData={() => deleteVehcileData(state.selNewModelRequestID)}
      />
      {/* =====================Status Change Model PopUp=============== */}
      <Modal size='lg' scrollable={true} show={showChange} onHide={handleCloseChange}>
        <div style={{backgroundColor: '#2a3952'}}>
          <Modal.Header closeButton>
            <Modal.Title style={{color: 'white'}}>Change Status</Modal.Title>
          </Modal.Header>
        </div>
        <Modal.Body>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'>
                <tbody className='border-bottom'>
                  <div className='row mb-6'>
                    <label className='col-lg-2 col-form-label required fw-bold fs-6'>Status:</label>
                    <div className='col-lg-6 fv-row'>
                      <select
                        className='form-select bg-light-primary'
                        aria-label='Default select example'
                        onChange={selectChange}
                        id='statusID'
                      >
                        <option selected={state.selStatusID === 0 ? true : false} value={0}>
                          Select Status
                        </option>
                        {modelStatusData.length > 0 &&
                          modelStatusData.map((data, index) => {
                            return (
                              <option
                                key={index}
                                value={data.statusID}
                                selected={data.statusID === state.selStatusID ? true : false}
                              >
                                {data.statusName}
                              </option>
                            )
                          })}
                      </select>
                    </div>
                  </div>

                  <div className='d-flex justify-content-end py-8'>
                    <Button
                      variant='success'
                      onClick={() =>
                        updateStatusData(state.selNewModelRequestID, state.selStatusID)
                      }
                    >
                      Save
                    </Button>
                    <Button variant='danger' onClick={handleCloseChange} className='ms-2'>
                      Close
                    </Button>
                  </div>
                  {/* )} */}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default NewModelRequestList
